import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import DataTable from "react-data-table-component";
import { isValidNumber } from "../../../common/Validations";
import ItemService from "../../../services/supplier_appCommonService";
import { InputField } from "../../../Components/formElements/InputField";
const HrProjectServices = React.forwardRef((props, ref) => {
  // eslint-disable-next-line no-unused-vars
  const [disabled, setDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [getDocumentIdData, setDocumentIdData] = useState([]);
  const ProjectServiceColumns = [
    {
      name: "Line Nr",
      cell: (row) => (
        <>
          <span>{row.serviceLineNr}</span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Task / Service Name",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="serviceName"
          placeholder=""
          value={row.serviceName || ""}
          onChange={(event) =>
            handleServiceInputChange(row.serviceLineNr, event)
          }
        />
      ),
      width: "220px",
    },
    {
      name: "Description",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="serviceDescription"
          placeholder=""
          value={row.serviceDescription || ""}
          onChange={(event) =>
            handleServiceInputChange(row.serviceLineNr, event)
          }
        />
      ),
      width: "260px",
    },
    {
      name: "Assigned To",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="assignedTo"
          placeholder=""
          value={row.assignedTo || ""}
          onChange={(event) =>
            handleServiceInputChange(row.serviceLineNr, event)
          }
        />
      ),
      width: "200px",
    },
    {
      name: "Planned Start Date",
      selector: (row) => row.startDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="startDate"
          placeholder=""
          value={row.startDate || ""}
          onChange={(event) =>
            handleServiceInputChange(row.serviceLineNr, event)
          }
        />
      ),
      width: "180px",
    },
    {
      name: "Planned End Date",
      selector: (row) => row.endDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="endDate"
          placeholder=""
          value={row.endDate || ""}
          onChange={(event) =>
            handleServiceInputChange(row.serviceLineNr, event)
          }
        />
      ),
      width: "180px",
    },
    {
      name: "Effort (Hrs/Days)",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="serviceQuantity"
          placeholder=""
          value={row.serviceQuantity || ""}
          onChange={(event) =>
            handleServiceInputChange(row.serviceLineNr, event)
          }
        />
      ),
      width: "160px",
    },
    {
      name: "UOM",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder="Hrs / Days"
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) =>
            handleServiceInputChange(row.serviceLineNr, event)
          }
        />
      ),
      width: "140px",
    },
    {
      name: "Delete",
      cell: (row, index) => (
        <>
          <span>
            <i
              onClick={() => handleDelete(index)}
              className="bi bi-trash close-btn"
            ></i>
          </span>
        </>
      ),
      width: "90px",
    },
  ];
  let ProjectServiceColumnsData = [
    {
      serviceLineNr: 1,
      serviceName: "",
      serviceDescription: "",
      assignedTo: "",
      startDate: "",
      endDate: "",
      serviceQuantity: 0,
      orderUnitOfMeasure: "",
    },
  ];
  const [getServicePOSelectedData, setServicePOSelectedData] = useState(
    ProjectServiceColumnsData,
  );
  const addServicePOItemRow = () => {
    setServicePOSelectedData((prevRows) => {
      const newRow = {
        ...ProjectServiceColumnsData[0],
        serviceLineNr: prevRows?.length + 1,
      };
      return [...prevRows, newRow];
    });
  };
  const handleServiceInputChange = (serviceLineNr, event) => {
    const { name, value } = event.target;
    if (name === "serviceQuantity" || name === "unitValue") {
      if (isValidNumber(value)) {
        setServicePOSelectedData((prevRows) =>
          prevRows.map((row) =>
            row.serviceLineNr === serviceLineNr
              ? {
                  ...row,
                  grossValue:
                    name === "serviceQuantity"
                      ? Number(value || 0) * Number(row.unitValue || 0)
                      : Number(row.serviceQuantity || 0) * Number(value || 0),
                  [name]: value,
                }
              : row,
          ),
        );
      }
    } else {
      setServicePOSelectedData((prevRows) =>
        prevRows.map((row) =>
          row.serviceLineNr === serviceLineNr ? { ...row, [name]: value } : row,
        ),
      );
    }
  };
  const handleDelete = (indexToDelete) => {
    setServicePOSelectedData((prevData) =>
      prevData.filter((_, index) => index !== indexToDelete),
    );
  };

  const handleSave = async () => {
    if (getServicePOSelectedData.length === 0) {
      setErrorMsg("* Add atleast one record");
      return;
    } else {
      setErrorMsg("");
    }

    props.servicescheduledata(getServicePOSelectedData);
    props.onHide();
  };

  useEffect(() => {
    if (props.showcurrentdata && props.showcurrentdata.length) {
      setServicePOSelectedData(props.showcurrentdata);
    } else {
      setServicePOSelectedData(ProjectServiceColumnsData);
    }

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  useEffect(() => {
    let isActive = true;
    if (isActive) {
      getMasterData();
    }
    // eslint-disable-next-line
  }, []);

  //Load Master Data
  const getMasterData = async () => {
    let obj1 = {
      codeType: props.masterdata,
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setDocumentIdData(item?.data);
      } else {
        setDocumentIdData([]);
        console.log(">> Error: Loading getSupplierDatail");
      }
    });
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      dialogClassName="modal-80w"
      backdrop="static"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <i className="bi bi-plus-lg"></i> {props.headername}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <div className="space-y-4">
          <Row>
            <Col xs={12} md={12} lg={12} className="headerButtonAlign">
              <Col xs={12} md={1} lg={1}>
                <button className="btnTable" onClick={addServicePOItemRow}>
                  <i className="bi bi-plus-lg"></i> Add
                </button>
              </Col>
            </Col>
            <Col xs={12} md={12} lg={12}>
              <DataTable
                columns={ProjectServiceColumns}
                data={getServicePOSelectedData}
                selectableRows
              />
            </Col>
          </Row>

          <Row className="justify-end">
            <Col xs={6} md={3} lg={2} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={3} lg={2} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleSave}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
                disabled={disabled}
              >
                Save
              </button>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              <p className="errorMsg"> {errorMsg} </p>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default HrProjectServices;
